import { type ValidateZipAdapter } from '../../validation/protocols/validate-zip-adapter'
import { validateCep } from 'validations-br'

export class ZipValidatorAdapter implements ValidateZipAdapter {
  validate (value: string): boolean {
    return validateCep(value)
  }
}
